import { render, staticRenderFns } from "./DomicilioPagoComponent.vue?vue&type=template&id=982638f4"
import script from "./DomicilioPagoComponent.vue?vue&type=script&lang=js"
export * from "./DomicilioPagoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports